export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';
export const REPORTING_TIMEZONE_DEFAULT = 'America/New_York';
export const APP_NAME = 'FieldOps Monitor';
export const DEMO_LABEL = 'DEMO MODE';
export const REFORGE_LOGO_SRC = '/branding/reforge-tech-logo.jpg';
export const REFORGE_POWERED_BY = 'Powered by Reforge Tech';
